import { render, staticRenderFns } from "./LogInPage.vue?vue&type=template&id=5afc0347&scoped=true&"
import script from "./LogInPage.vue?vue&type=script&lang=js&"
export * from "./LogInPage.vue?vue&type=script&lang=js&"
import style0 from "./LogInPage.vue?vue&type=style&index=0&id=5afc0347&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afc0347",
  null
  
)

export default component.exports